// extracted by mini-css-extract-plugin
export default {"Wedding":"Weddings_Wedding__TVnxI","textBlockFirst":"Weddings_textBlockFirst__kSWeJ","images":"Weddings_images__ztyyQ","textBlockSecond":"Weddings_textBlockSecond__uyWRa"};